export default "__VITE_ASSET__CxtMxW92__"